<template>
  <img :src="format(value)" :alt="name" v-if="isPicture" />
  <div v-else-if="isComponent">
    <slot :data="userData" />
  </div>
  <span v-else>
    {{ format ? format(value) : value }}
  </span>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UserPropertyComponent',
  components: {},
  props: {
    name: {
      type: String,
      default: '',
    },
    isMetaProperty: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    format: {
      type: Function,
      default(value) {
        return value
      },
    },
    isPicture: {
      type: Boolean,
      default: false,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.defaultValue,
      eventsIds: [],
      userData: {},
    }
  },
  mounted() {
    this.loadProperty()
    setTimeout(this.loadProperty, 500)
    setTimeout(this.loadProperty, 1000)
    setTimeout(this.loadProperty, 2000)
    const id = this.$Events.handleEvent('user_updated', this.loadProperty)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    this.unsubscribeToAppInfoResponse()
  },
  methods: {
    async loadProperty() {
      this.unsubscribeToAppInfoResponse()
      const { unsubscribe } = this.$Events.sendDataRequest(
        'userData',
        this.onUserGot,
      )
      this.unsubscribeToAppInfoResponse = unsubscribe
    },
    unsubscribeToAppInfoResponse() {},
    onUserGot(user) {
      if (!user) {
        this.value = this.defaultValue
        this.$forceUpdate()
        return
      }

      this.userData = user
      this.$emit('dataAvailable', user)

      if (this.$Commons.isEmpty(this.name)) {
        this.value = this.defaultValue
        return
      }

      let value = null
      value = user[this.name]
      if (this.isMetaProperty || value == undefined || value == null)
        value = user.metaData[this.name]
      if (value == null || value == undefined) value = this.defaultValue
      this.value = value
      this.$forceUpdate()
    },
  },
  watch: {
    _props: {
      deep: true,
      handler() {
        this.loadProperty()
      },
    },
  },
})
</script>
